export default __webpack_public_path__ + "static/logos-thumbnail-98f44f9c26b8015f3dfd7a12f9f4547f.jpg";